import { FC, useCallback } from 'react';

import Small from './Small';
import TruncatedTextWithTooltip, {
    TruncatedTextWithTooltipContentProps,
} from './TruncatedTextWithTooltip';

type Props = {
    className?: string;
    title: string;
};

export const AccountTitle: FC<Props> = ({ title, className }) => {
    const renderContent = useCallback(
        (props: TruncatedTextWithTooltipContentProps) => <Small {...props}>{title}</Small>,
        [title]
    );

    return (
        <TruncatedTextWithTooltip
            text={title}
            className={className}
            renderContent={renderContent}
        />
    );
};

export default AccountTitle;
